import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const headers = {
  Authorization: process.env.REACT_APP_JHED,
}

// Search for courses given a query; return empty array if no match or error
async function retrieve(toMatch = "") {
  try {
    if (!toMatch.trim()) return { data: [] };
    const response = await axios.get(`${BASE_URL}/api/search?query=${toMatch.trim()}`, { headers });
    return response.data;
  } catch (err) {
    console.log(err);
    return [];
  }
}

// Send request to api given any url (has to be valid for useful info to be returned);
// mainly used for navigating through the pagination of search results
async function nav(url) {
  try {
    const response = await axios.get(url, { headers });
    return response.data;
  } catch (err) {
    console.log(err);
    return [];
  }
}

// Get all the courses in db
async function getAll() {
  try {
    const response = await axios.get(`${BASE_URL}/api/courses`, { headers });
    return response.data.data;
  } catch (err) {
    console.log(err);
    return [];
  }
}

// Remove specified course from db
async function remove(id) {
  try {
    const response = await axios.delete(`${BASE_URL}/api/courses/${id}`, { headers });
    return response.data.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}

// Add specified course to db
async function add(course) {
  try {
    const response = await axios.post(`${BASE_URL}/api/courses`, course, { headers });
    return response.data.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}

// Update status of specified course in db
async function patch(id, status) {
  try {
    const response = await axios.patch(`${BASE_URL}/api/courses/${id}`, { status }, { headers });
    return response.data.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}

export { retrieve, nav, getAll, remove, add, patch };
